import { Box, Typography } from "@material-ui/core";
import React from "react";

interface TabPanelProps {
  children: any;
  index: number;
  value: any;
}

const TabPanel: React.FC<TabPanelProps> = ({
  children,
  index,
  value,
  ...other
}) => {
  return (
    <div
      style={{ flex: 1 }}
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      <Box p={3}>
        <Typography component={"div"}>{children}</Typography>
      </Box>
    </div>
  );
};

export default TabPanel;
